import React from 'react';
import './index.css';
import { Step2Props } from '../../../../../redux/AllocationRequest';

export const Step2: React.FC<Step2Props> = ({ details, onChange }) => {
  return (
    <div className="step2-container">
      <p className="step2-title">Request Details</p>
      
      <div className="step2-section">
        <label className="step2-label">Department</label>
        <input 
          type="text"
          value={details.department}
          onChange={e => onChange("department", e.target.value)}
          placeholder="Enter department name"
          className="step2-input"
        />
      </div>

      <div className="step2-section">
        <label className="step2-label">Requested By</label>
        <div className="step2-user-info">
          <input 
            type="text"
            value={details.requestedBy || " "}
            onChange={e => onChange("requestedBy", e.target.value)}
            placeholder="Enter requester name"
            className="step2-input"
          />
        </div>
      </div>

      <div className="step2-grid">
        <div>
          <label className="step2-label">Target Date</label>
          <input 
            type="date" 
            value={details.targetDate} 
            onChange={e => onChange("targetDate", e.target.value)}
            className="step2-input" 
          />
        </div>
      </div>

      <div className="step2-section">
        <label className="step2-label">Notes (Optional)</label>
        <textarea 
          value={details.notes} 
          onChange={e => onChange("notes", e.target.value)} 
          placeholder="Add any additional notes or context..."
          className="step2-textarea"
        />
      </div>
    </div>
  );
};